import React, { useState } from "react";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const DatePickerField = ({ label, name, value, onChange }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="relative mb-6">
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          selected={value ? moment(value).toDate() : null} // Ensure the date is parsed correctly
          onChange={(date) =>
            onChange({
              target: { name, value: moment(date).format("YYYY-MM-DD") },
            })
          }
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(!!value)} // Keep label floated if there's a value
          className={`peer w-full border border-[#CFCFCF] rounded-lg py-3 px-4 text-sm bg-[#F7F7F7] outline-none focus:ring-2 focus:ring-blue-500 font-outfit`}
          dateFormat="yyyy-MM-dd"
          sx={{
            ".MuiFormControl-root": {
              border: "none",
              //   padding: 0,
            },
            ".MuiInputBase-root": {
              border: "none",
              //   padding: 0,
            },
            ".MuiOutlinedInput-notchedOutline": {
              //   border: "none",
              border: "1px solid #CFCFCF",
              borderRadius: "0.5rem",
              fontFamily: "Outfit, sans-serif",
              //   padding: 0,
            },
            ".MuiInputBase-input": {
              border: "none",
              paddingInline: "1rem",
              paddingBlock: "0.75rem",
              fontFamily: "Outfit, sans-serif",
              borderRadius: "1rem",
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DatePickerField;
